import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray,FormControl, ValidatorFn } from '@angular/forms';
import * as _ from "lodash";
import * as ent from '../entities/index'
import { ValidationTypeEnum } from '../enums/index';
import { L } from '@angular/core/src/render3';



export function dropDownValidator(control: FormControl) {
    if (control.value < 0 || !control.value ) {
        return { invalid: true };
    }
    return null;
}

export function hiddenDropDownValueValidator(control: FormControl) {
  
    if (control.value == -2 ) {
        return { invalid: true };
    }
    return null;
}

export function postalCodeValidator(control: FormControl) {
  
    if (control.value){
        var s = control.value.replace(/[^0-9a-zA-Z]/g, '');
        if (s.length != 5 && s.length != 9){
            return { invalid: true };
        }
    }
    return null;
}

export function commissionRateValidator(control: FormControl) {
  
    if (control.value === undefined || isNaN(control.value) || control.value < 0 ){
        return { invalid: true };
    }
    return null;
}

export function vendPriceValidator(control: FormControl) {
  
    if (control.value === undefined || isNaN(control.value) || control.value <= 0 ){
        return { invalid: true };
    }
    return null;
}

export function  emailValidatorWithParameters(contactValidations: ent.ContactValidation[]) : ValidatorFn {
    return (control: FormControl) : {[key: string] : any | null} => {
        if (control.value)
        {
            const parts = control.value.split('@');

            if (parts.length > 1) {
                const parts2 = parts[1].split('.');
                if (parts2.length > 1) {
                    for (var cv of contactValidations.filter(x=>x.ValidationTypeID == ValidationTypeEnum.EmailDomain)) {
                        if (parts2[0].toUpperCase() == cv.Value.toUpperCase()) {
                            return {customError: `Invalid Domain: ${cv.Value}`};
                        }
                    }
                }
                for (var cv of contactValidations.filter(x=>x.ValidationTypeID == ValidationTypeEnum.EmailName)) {
                    if (parts[0].toUpperCase() == cv.Value.toUpperCase()) {
                        return {customError: `Invalid Name: ${cv.Value}`};
                    }
                }
            }
        }
        return null;
    }
}

export function phoneRequiredValidator(control: FormControl) {
  
    var phone = control.value;
    if (!phone) {
        return { required: true };
    }
    if (phone == "___-___-____") {
        return { required: true };
    }
    return null;
}

export function emailValidator(control: FormControl) {
  
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    var email = control.value;
    if (email){
        
        if (!re.test(email)){
            return { invalid: true };
        }
    }
    return null;
}

export function  phoneNumberValidatorWithParameters(contactValidations: ent.ContactValidation[]) : ValidatorFn {
    return (control: FormControl) : {[key: string] : any | null} => {
        if (control.value)
        {
            for (var cv of contactValidations.filter(x=>x.ValidationTypeID == ValidationTypeEnum.PhoneNumber)) {
                if (control.value == cv.Value) {
                    return {invalid: true};
                }
            }
        }
        return null;
    }
}
